import {
  ForwardRefExoticComponent,
  type SVGProps,
  forwardRef,
  ReactNode,
} from 'react'
import { cn } from '@vgw/tailwind-merger'

type IconProperties = SVGProps<SVGSVGElement> & {
  className?: string
} & { title?: string; titleId?: string }

export function createIcon(
  IconComponent: ForwardRefExoticComponent<
    SVGProps<SVGSVGElement> & { title?: string; titleId?: string }
  >,
  iconName: string,
): IconComponent {
  const Component = forwardRef<SVGSVGElement, IconProperties>(
    ({ className, ...props }, ref) => {
      return (
        <IconComponent
          ref={ref}
          className={cn('size-[1em] fill-current', className)}
          {...props}
        />
      )
    },
  )

  Component.displayName = iconName
  return Component
}

export type IconComponent = (props: IconProperties) => ReactNode
